import { render, staticRenderFns } from "./boton.vue?vue&type=template&id=5db05763"
import script from "./boton.vue?vue&type=script&lang=js"
export * from "./boton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports